var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product fs-16 product-center"},[_c('div',{staticClass:"cont"},_vm._l((_vm.dataList),function(o,i){return _c(_vm.componentMap[o.moduleType],{key:i,tag:"component",attrs:{"info":o}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }